import type { EntityKind, Id } from "./types";

const PREFIX: Record<EntityKind, string> = { workspace: "ws", category: "cat", action: "act" };

function uuid(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  // randomUUID needs a secure context; getRandomValues does not (e.g. opening the dev server by LAN IP).
  const b = new Uint8Array(16);
  c.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map(x => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** New permanent id, e.g. "cat_2f1c…". Never regenerated on edit, import or export. */
export const newId = (kind: EntityKind): Id => `${PREFIX[kind]}_${uuid()}`;
